import * as React from "react";
import "./global.css";
import checkmarkSvg from "src/images/checkmark.svg";
import closeSvg from "src/images/close.svg";
import { getURLParameter } from "./src/helpers/getURLParameter";
import { setCookie } from "./src/helpers/setCookie";

export const onInitialClientRender = () => {
  // Disable prefetching on initial page load
  if (typeof window !== "undefined") {
    window.___loader = { enqueue: () => {}, hovering: () => {} };
  }

  /*
    Cookie methods:
    Sets necessary tracking cookies in production
  */
  if (process.env.GATSBY_REPLACE_ENV === "production") {
    const expiryDays = 30;

    const gclid = getURLParameter("gclid");
    if (gclid) setCookie("_gclid", gclid, expiryDays);

    const fbclid = getURLParameter("fbclid");
    if (fbclid) setCookie("_fbc", `fb.${fbclid}`, expiryDays);

    const wbraid = getURLParameter("wbraid");
    if (wbraid) setCookie("_wbraid", wbraid, expiryDays);

    const gbraid = getURLParameter("gbraid");
    if (gbraid) setCookie("_gbraid", gbraid, expiryDays);
  }
};

/*
  Prefetching:
*/
// Disable prefetching on client entry
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    window.___loader = { enqueue: () => {}, hovering: () => {} };
  }
};
// Disable prefetching on route updates
export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    window.___loader = { enqueue: () => {}, hovering: () => {} };
  }
};

/*
  Citation methods:
  When a citation is hovered over, the citation will be displayed in a "tooltip".
*/
let citationPopup = null;
let citationTimeout = null;

window.onMouseOverCitation = function (event) {
  // If window is smaller than 1280px, revert to mobile behavior
  if (window.innerWidth < 1280) return;

  if (citationTimeout) clearInterval(citationTimeout);

  renderCitation(event);
};

window.onMouseOutCitation = function (event) {
  // If window is smaller than 1280px, revert to mobile behavior
  if (window.innerWidth < 1280) return;

  if (citationTimeout) clearInterval(citationTimeout);

  citationTimeout = setTimeout(() => {
    destroyCitation(event);
  }, 300);
};

window.onCitationClick = function (event) {
  // If window is larger than 1280px, revert to desktop behavior
  if (window.innerWidth > 1280) return;
  renderCitation(event);
};

window.onCitationCloseClick = function (event) {
  // If window is larger than 1280px, revert to desktop behavior
  if (window.innerWidth > 1280) return;
  destroyCitation(event);
};

const renderCitationDOM = (linkTitle, linkUrl, dateFetched) => {
  return `
        <div class="close" onClick="onCitationCloseClick(event)">${closeSvg}</div>
        <div class="heading">
            <span>${checkmarkSvg}</span>
            <span>Pålitlig källa</span>
        </div>
        <div>Detta är en verifierad källa som har granskats av Credwises faktagranskare.</div>
        <div class="link"><a href="${linkUrl}" target="_blank">${linkTitle}</a></div>
        <div class="date"><em>Hämtad: ${dateFetched}</em></div>
    `;
};

const renderCitation = (event) => {
  const currentTarget = event.currentTarget;

  if (!citationPopup) {
    try {
      const linkTitle = currentTarget.getAttribute("data-citation-link-title");
      const linkUrl = currentTarget.getAttribute("data-citation-link-url");
      const dateFetched = currentTarget.getAttribute(
        "data-citation-date-fetched"
      );

      const scrollTop = document.documentElement.scrollTop;
      const scrollLeft = document.documentElement.scrollLeft;

      const top = currentTarget.getBoundingClientRect().top + scrollTop + "px";
      const left =
        currentTarget.getBoundingClientRect().left +
        currentTarget.getBoundingClientRect().width / 2 +
        scrollLeft +
        "px";

      citationPopup = document.createElement("div");
      citationPopup.setAttribute(
        "data-index",
        currentTarget.getAttribute("data-index")
      );
      citationPopup.classList.add("citation-popup");
      citationPopup.innerHTML = renderCitationDOM(
        linkTitle,
        linkUrl,
        dateFetched
      );
      citationPopup.style.top = top;
      citationPopup.style.left = left;

      citationPopup.addEventListener("mouseover", window.onMouseOverCitation);
      citationPopup.addEventListener("mouseout", window.onMouseOutCitation);

      document.body.appendChild(citationPopup);
    } catch (e) {
      console.error("Error creating citation popup:", e);
    }
  } else {
    try {
      const newIndex = currentTarget.getAttribute("data-index");
      const citationIndex = citationPopup.getAttribute("data-index");

      if (newIndex !== citationIndex) {
        destroyCitation(event);
        renderCitation(event);
      }
    } catch (e) {
      console.error("Error updating citation popup:", e);
    }
  }
};

const destroyCitation = (event) => {
  if (citationPopup) {
    citationPopup.removeEventListener("mouseover", window.onMouseOverCitation);
    citationPopup.removeEventListener("mouseout", window.onMouseOutCitation);
    citationPopup.remove();
    citationPopup = null;
  }
};
